// extracted by mini-css-extract-plugin
export var blue = "_16-g";
export var brand = "_16-c";
export var darkGrey = "_16-f";
export var disabled = "_16-6";
export var disabledSubtle = "_16-7";
export var error = "_16-8";
export var green = "_16-h";
export var grey = "_16-e";
export var icon = "_16-0";
export var inherit = "_16-b";
export var lightGrey = "_16-d";
export var orange = "_16-j";
export var pink = "_16-l";
export var primary = "_16-1";
export var purple = "_16-m";
export var quaternary = "_16-4";
export var quinary = "_16-5";
export var red = "_16-k";
export var secondary = "_16-2";
export var success = "_16-a";
export var tertiary = "_16-3";
export var warning = "_16-9";
export var white = "_16-n";
export var yellow = "_16-i";